<template>
  <div class="privacy-container">
    <article class="privacy-content">

      <SimpleHeader 
          title="私隱政策" 
          subtitle="生效日期：YYYY年MM月DD日"
        />

      <section class="policy-section">
        <p class="intro-text">歡迎訪問<span class="brand">[公司名稱]</span>（以下簡稱「我們」或「本公司」）的網站。我們非常重視您的私隱，並致力於保護您的個人信息。請您仔細閱讀本私隱政策，以了解我們如何收集、使用、存儲和保護您的信息。</p>

        <div class="policy-article" v-for="section in policySections" :key="section.title">
          <h2 class="section-title">{{ section.title }}</h2>
          <div class="section-content">
            <p v-if="section.description">{{ section.description }}</p>
            <ul v-if="section.listItems" class="policy-list">
              <li v-for="(item, index) in section.listItems" :key="index">
                <span class="list-icon">•</span>
                <span v-html="item"></span>
              </li>
            </ul>
          </div>
        </div>

        <div class="contact-info">
          <h2 class="section-title">7. 聯繫我們</h2>
          <p>如果您對本私隱政策有任何疑問或意見，請通過以下方式與我們聯繫：</p>
          <ul class="contact-list">
            <li>
              <i class="bi bi-envelope"></i>
              <span>電子郵件：</span>
              <a href="mailto:contact@company.com">contact@company.com</a>
            </li>
            <li>
              <i class="bi bi-telephone"></i>
              <span>電話：</span>
              <a href="tel:+85212345678">+852 1234 5678</a>
            </li>
            <li>
              <i class="bi bi-geo-alt"></i>
              <span>地址：</span>
              香港中環金融街8號國際金融中心
            </li>
          </ul>
        </div>

        <footer class="policy-footer">
          <p class="acknowledgement">感謝您對<span class="brand">[公司名稱]</span>的信任與支持！</p>
        </footer>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      policySections: [
        {
          title: "1. 信息的收集",
          listItems: [
            "<strong>個人信息</strong>：當您註冊賬戶、填寫表單或與我們聯繫時，我們可能會收集您的姓名、電子郵件地址、電話號碼等個人信息。",
            "<strong>非個人信息</strong>：我們可能會收集有關您訪問我們網站的非個人信息，例如瀏覽器類型、IP位址、訪問時間和頁面瀏覽記錄等。"
          ]
        },
        {
          title: "2. 信息的使用",
          listItems: [
            "提供和維護我們的服務",
            "改進我們的產品和服務",
            "與您溝通，包括發送更新、促銷信息和客戶支持",
            "分析網站使用情況，以優化用戶體驗"
          ]
        },
        {
          title: "3. 信息的分享",
          listItems: [
            "在法律要求的情況下，或為了保護我們的權利、私隱、安全或財產。",
            "與我們的服務提供商合作，以幫助我們提供服務，但這些服務提供商必須遵守保密義務。"
          ]
        },
        {
          title: "4. 信息的安全",
          description: "我們採取合理的技術和管理措施來保護您的個人信息，防止未經授權的訪問、使用或泄露。然而，請注意，任何數據傳輸都無法保證百分之百的安全性。"
        },
        {
          title: "5. 您的權利",
          description: "您有權訪問、更正或刪除我們所持有的您的個人信息。您可以通過聯繫我們來行使這些權利。"
        },
        {
          title: "6. 私隱政策的變更",
          description: "我們可能會不時更新本私隱政策。我們會在網站上發佈更新的私隱政策，並在生效日期前通知您。請定期查看本政策以了解最新信息。"
        }
      ]
    };
  }
};
</script>

<style scoped>
.privacy-container {
  max-width: 1280px;
  margin: 0 auto;
  /* padding: 4rem 2rem; */
  font-family: 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
}

.privacy-header {
  text-align: center;
  margin-bottom: 3rem;
}

.privacy-header h1 {
  font-size: 2.5rem;
  color: #1a2943;
  margin-bottom: 1rem;
}

.effective-date {
  color: #718096;
  font-size: 0.9rem;
}

.policy-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 3rem;
}

.intro-text {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 2.5rem;
}

.brand {
  color: #3F81FE;
  font-weight: 600;
}

.policy-article {
  margin-bottom: 2.5rem;
}

.section-title {
  font-size: 1.5rem;
  color: #1a2943;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
}

.policy-list {
  list-style: none;
  padding-left: 1.5rem;
}

.policy-list li {
  margin-bottom: 1rem;
  position: relative;
  color: #4a5568;
}

.list-icon {
  position: absolute;
  left: -1.5rem;
  color: #3F81FE;
  font-weight: bold;
}

.contact-info {
  background: #f8fafc;
  border-radius: 8px;
  padding: 2rem;
  margin: 3rem 0;
}

.contact-list {
  list-style: none;
  padding-left: 0;
}

.contact-list li {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  color: #4a5568;
}

.contact-list i {
  margin-right: 0.8rem;
  color: #3F81FE;
  font-size: 1.2rem;
}

.contact-list a {
  color: #3F81FE;
  text-decoration: none;
  transition: opacity 0.2s;
}

.contact-list a:hover {
  opacity: 0.8;
}

.policy-footer {
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
}

.acknowledgement {
  font-size: 1.1rem;
  color: #4a5568;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 2rem 1rem;
  }

  .privacy-header h1 {
    font-size: 2rem;
  }

  .policy-section {
    padding: 2rem;
  }

  .section-title {
    font-size: 1.3rem;
  }
}
</style>